import connection from "./connection";
import axios from "axios";
import {AdjusmentNoteRequest, AdjustmentNoteReq, AdjutsmentNoteCategoryReq, PurchaseRequest} from 'libs/shared-models/finance/src'
import { CommonResponse } from "@gtpl/shared-models/masters";

export class PurchasesProductService{
    URL = connection.DEPLOY_URL + '/purchases';

    async createPurchase(request: PurchaseRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createPurchase', request)
            .then(res => {
                return res.data
            })
    }
    async getAllProducts(): Promise<CommonResponse> {  
        console.log(URL,"urlllllllllllllllll");
 
        return await axios.post(this.URL + '/getAllProducts')
            .then(res => {
                return res.data
            })
    }
    async getViewForAllProducts(req:any): Promise<CommonResponse> {
        console.log(req,'@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@');
        
        return await axios.post(this.URL + '/getViewForAllProducts',req)
            .then(res => {
                console.log(res.data,'9999999999999999999999');
                return res.data
            })
            
        }

    async getAllVendorNamesForView(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllVendorNamesForView',req)
            .then(res => {
                return res.data
            })
    }

    async getAllInvoiceNumber(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllInvoiceNumber',req)
            .then(res => {
                return res.data
            })
    }

    async getAllCompanys(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllCompanys')
            .then(res => {
                return res.data
            })
    }

    async getAllUnits(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllUnits')
            .then(res => {
                return res.data
            })
    }

    async getDetailedViewForProductPurchase(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDetailedViewForProductPurchase',req)
            .then(res => {
                return res.data
            })
    }

    
}